import * as dom from '@srhazi/simpledom';
import './responsive.css';

const updateWidth = () => {
    dom.all(HTMLElement, '.viewport-width').forEach((el) => {
        el.textContent = `${window.innerWidth}`;
    });
};

window.addEventListener('resize', updateWidth);
updateWidth();
